import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addVideo } from 'slice/videoSlice';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const Add = () => {
    const [videoName, setVideoName] = useState('');
    const [videoFile, setVideoFile] = useState(null);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading } = useSelector((state) => state.video);

    const handleFileChange = (e) => {
        setVideoFile(e.target.files[0]);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!videoFile) {
            toast.error('Please select a video file');
            return;
        }

        const data = new FormData();
        data.append('videoName', videoName);
        data.append('video', videoFile);

        dispatch(addVideo(data));
        toast.success('Video upload started...');
        setTimeout(() => navigate('/khajuraho/videos'), 1500);
    };

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4">
                <h4 className="text-white font-weight-bold">Add Promotional Video</h4>
            </div>
            <form onSubmit={handleSubmit} className="bg-white p-4 mx-4 mt-5 rounded shadow">
                <div className="row">
                    <div className="col-sm-6 mt-2">
                        <label htmlFor="videoName" className="adminlables">Video Name / Title</label>
                        <input 
                            type="text" 
                            id="videoName"
                            value={videoName} 
                            className="form-control" 
                            onChange={(e) => setVideoName(e.target.value)} 
                            required 
                            placeholder="e.g. Khajuraho Temple Tour"
                        />
                    </div>
                    <div className="col-sm-6 mt-2">
                        <label htmlFor="videoFile" className="adminlables">Select Video File</label>
                        <input 
                            type="file" 
                            id="videoFile"
                            className="form-control filebg" 
                            onChange={handleFileChange} 
                            required 
                            accept="video/*"
                        />
                    </div>
                </div>
                <div className="mt-5 text-right">
                    <button type="submit" className="btn btn-lg addbtn" disabled={loading}>
                        {loading ? 'Uploading...' : 'Upload Video'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default Add;
